import * as React from 'react'
import { FullImageWidgetConnected } from './FullImageWidgetConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const FullImageWidgetExamples = () => {
  return (
    <div className="FullImageWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <FullImageWidgetConnected />
      </Provider>
    </div>
  )
}
